import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {withContext} from '../../../custom/StateProvider';
import {connect} from "react-redux";
import {API, BROKER_NAME} from "../../../../config";
import Utils from "../../../custom/utils";

const wallet = API.service('wallet');
const moment = require('moment-timezone');

const styles = theme => ({
  root                    : {},

  avatar                  : {},

  reportTable             : {
    width                 :'100%',
    paddingTop            : '30px'
  },

  reportHeading           : {
    fontWeight            :'bold'
  }
});

class InvestorBalance extends Component {
  state = {
    balances: false
  }

  componentDidMount() {
    const app = this;
    wallet.find({query:{type:'balance_period',_currency:'USD',_timestamp:moment().utc()}}).then(b=>{
      console.log(b)
      wallet.find({query:{type:'balance_period',_currency:'EUR',_timestamp:moment().utc()}}).then(b2=>{
        console.log(b2)
        wallet.find({query:{type:'balance_period',_currency:'ANG',_timestamp:moment().utc()}}).then(b3=>{
          console.log(b3)
          wallet.find({query:{type:'balance_period',_currency:'GBP',_timestamp:moment().utc()}}).then(b4=>{
            console.log(b4)
            app.setState({
              balances:{'usd':b,'eur':b2,'ang':b3,'gbp':b4}
            })
          })
        })
      })
    })
  }

  investorState(state) {
    let InvStatus = Utils.returnState(state);
    return(
      <div className={'kyc-label ' + InvStatus[0]}>{InvStatus[1]}</div>
    )
  }

  render() {
    //const { classes} = this.props;
    //let count = 0;
    return (
      <React.Fragment>

        { (this.state.balances !== false) &&
          <table width={"100%"}>
            <tr>
              <td colSpan="2" style={{textAlign:'right',padding:"3px 10px"}}><b>Effective Date:</b></td>
              <td colSpan="2" style={{textAlign:'left',padding:"3px 10px"}}><b>{moment().tz('America/New_York').format('MMMM Do YYYY, h:mm:ss a')}</b></td>
            </tr>
            <tr>
              <td colSpan="2" style={{textAlign:'right',padding:"3px 10px"}}><b>Prepared By:</b></td>
              <td colSpan="2" style={{textAlign:'left',padding:"3px 10px"}}><b>{BROKER_NAME}</b></td>
            </tr>
            <tr>
              <td colSpan={5}>&nbsp;</td>
            </tr>
            <tr>
              <td width={"20%"}><b>Currency</b></td>
              <td width={"20%"}><b>Balance</b></td>
              <td width={"20%"}><b>Frozen</b></td>
              <td width={"20%"}><b>Last Change</b></td>
              <td width={"20%"}><b>Total</b></td>
            </tr>
            <tr>
              <td>USD</td>
              <td>${Utils.addThousandCommas(parseFloat(this.state.balances.usd.balance))}</td>
              <td>${Utils.addThousandCommas(parseFloat(this.state.balances.usd.frozen) - parseFloat(this.state.balances.usd.released))}</td>
              <td>{(!Utils.isEmpty(this.state.balances.usd.last_change)) ? moment(this.state.balances.usd.last_change).format('YYYY-MM-DD') : '' }</td>
              <td>${Utils.addThousandCommas(parseFloat(this.state.balances.usd.balance) + (parseFloat(this.state.balances.usd.frozen) - parseFloat(this.state.balances.usd.frozen)))}</td>
            </tr>
            <tr>
              <td>XCG</td>
              <td>Cg{Utils.addThousandCommas(parseFloat(this.state.balances.ang.balance))}</td>
              <td>Cg{Utils.addThousandCommas(parseFloat(this.state.balances.ang.frozen) - parseFloat(this.state.balances.ang.released))}</td>
              <td>{(!Utils.isEmpty(this.state.balances.ang.last_change)) ? moment(this.state.balances.ang.last_change).format('YYYY-MM-DD') : '' }</td>
              <td>Cg{Utils.addThousandCommas(parseFloat(this.state.balances.ang.balance) + (parseFloat(this.state.balances.ang.frozen) - parseFloat(this.state.balances.ang.frozen)))}</td>
            </tr>
            <tr>
              <td>EUR</td>
              <td>€{Utils.addThousandCommas(parseFloat(this.state.balances.eur.balance))}</td>
              <td>€{Utils.addThousandCommas(parseFloat(this.state.balances.eur.frozen) - parseFloat(this.state.balances.eur.released))}</td>
              <td>{(!Utils.isEmpty(this.state.balances.eur.last_change)) ? moment(this.state.balances.eur.last_change).format('YYYY-MM-DD') : '' }</td>
              <td>€{Utils.addThousandCommas(parseFloat(this.state.balances.eur.balance) + (parseFloat(this.state.balances.eur.frozen) - parseFloat(this.state.balances.eur.frozen)))}</td>
            </tr>
            <tr>
              <td>GBP</td>
              <td>£{Utils.addThousandCommas(parseFloat(this.state.balances.gbp.balance))}</td>
              <td>£{Utils.addThousandCommas(parseFloat(this.state.balances.gbp.frozen) - parseFloat(this.state.balances.gbp.released))}</td>
              <td>{(!Utils.isEmpty(this.state.balances.gbp.last_change)) ? moment(this.state.balances.gbp.last_change).format('YYYY-MM-DD') : '' }</td>
              <td>£{Utils.addThousandCommas(parseFloat(this.state.balances.gbp.balance) + (parseFloat(this.state.balances.gbp.frozen) - parseFloat(this.state.balances.gbp.frozen)))}</td>
            </tr>
          </table>
        }

      {(this.state.balances === false) &&
        <div style={{marginTop:15,textAlign:'center'}}>No Results</div>
      }
      </React.Fragment>
    )
  }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(InvestorBalance))));
